<template>
  <aside class="sidebar" :class="{ 'sidebar-hidden': isNavbarHidden }">
    <div class="sidebar-header">
      <div>
        <p class="sidebar-eyebrow">Seller Workspace</p>
        <h2>卖家后台</h2>
      </div>
      <div class="shop-name" v-if="shopName">{{ shopName }}</div>
    </div>

    <nav class="sidebar-nav">
      <div v-for="(section, index) in navSections" :key="index" class="nav-section">
        <button type="button" class="nav-title" @click="toggleSection(index)">
          <span>{{ section.title }}</span>
          <span class="toggle-icon" :class="{ expanded: section.expanded }">›</span>
        </button>
        <ul class="nav-list" :class="{ expanded: section.expanded }">
          <li v-for="(item, itemIndex) in section.items" :key="itemIndex">
            <router-link :to="item.path" class="nav-link" :class="{ active: isCurrentPath(item.path) }">
              <span class="nav-item-text">{{ item.name }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'SellerSidebar',
  computed: {
    shopName() {
      return localStorage.getItem('shopName') || ''
    }
  },
  data() {
    return {
      isNavbarHidden: false,
      lastScrollTop: 0,
      navSections: [
        {
          title: '概览',
          expanded: true,
          items: [
            { name: '后台首页', path: '/seller/dashboard' }
          ]
        },
        {
          title: '商品管理',
          expanded: true,
          items: [
            { name: '发布商品', path: '/seller/dashboard/product/new' },
            { name: '商品历史', path: '/seller/dashboard/products' },
            { name: '库存日志', path: '/seller/dashboard/stock-logs' }
          ]
        },
        {
          title: '分类管理',
          expanded: true,
          items: [
            { name: '一级分类', path: '/seller/dashboard/categories' },
            { name: '二级分类', path: '/seller/dashboard/sub-categories' }
          ]
        },
        {
          title: '订单与客户',
          expanded: true,
          items: [
            { name: '订单管理', path: '/seller/dashboard/buyers' },
            { name: '客户管理', path: '/seller/dashboard/customers' },
            { name: '配送管理', path: '/seller/dashboard/deliveries' },
            { name: '售后服务', path: '/seller/dashboard/after-sales' }
          ]
        },
        {
          title: '经营增长',
          expanded: true,
          items: [
            { name: '优惠营销', path: '/seller/dashboard/promotions' }
          ]
        },
        {
          title: '系统设置',
          expanded: true,
          items: [
            { name: '修改密码', path: '/seller/dashboard/change-password' },
            { name: '商户管理', path: '/seller/dashboard/manage' },
            { name: 'AI 试衣模型', path: '/seller/dashboard/try-on/models' },
            { name: 'AI 试衣数据', path: '/seller/dashboard/try-on/usage' },
            { name: '返回买家平台', path: '/' }
          ]
        }
      ]
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleSection(index) {
      this.navSections[index].expanded = !this.navSections[index].expanded
    },
    isCurrentPath(path) {
      return this.$route.path === path
    },
    handleScroll() {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.isNavbarHidden = currentScrollTop > this.lastScrollTop && currentScrollTop > 100
      this.lastScrollTop = currentScrollTop
    }
  }
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 86px;
  left: 0;
  width: 260px;
  height: calc(100vh - 102px);
  margin-left: 16px;
  padding: 1rem;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: var(--backdrop-blur);
  -webkit-backdrop-filter: var(--backdrop-blur);
  border: 1px solid var(--color-border);
  border-radius: 28px;
  box-shadow: var(--shadow-soft);
  transition: top var(--duration-base) var(--ease-standard);
}

.sidebar-hidden {
  top: 14px;
}

.sidebar-header {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.5rem 0.4rem 1.1rem;
  margin-bottom: 0.8rem;
  border-bottom: 1px solid var(--color-border);
}

.sidebar-eyebrow {
  margin: 0;
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-text-faint);
}

.sidebar-header h2 {
  margin: 0;
  color: var(--color-text);
  font-size: 1.45rem;
  font-weight: 600;
}

.shop-name {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  background: rgba(0, 113, 227, 0.08);
  color: var(--color-accent-strong);
  font-size: 0.84rem;
  font-weight: 600;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.nav-section {
  padding: 0.2rem 0;
}

.nav-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.72rem 0.9rem;
  background: rgba(15, 23, 42, 0.03);
  border: 1px solid transparent;
  border-radius: 16px;
  color: var(--color-text);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color var(--duration-fast) var(--ease-standard),
    border-color var(--duration-fast) var(--ease-standard);
}

.nav-title:hover {
  background: rgba(15, 23, 42, 0.05);
  border-color: var(--color-border);
}

.toggle-icon {
  color: var(--color-text-faint);
  transform: rotate(0deg);
  transition: transform var(--duration-fast) var(--ease-standard);
}

.toggle-icon.expanded {
  transform: rotate(90deg);
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0.45rem 0 0 0;
  display: none;
}

.nav-list.expanded {
  display: grid;
  gap: 0.3rem;
}

.nav-link {
  display: flex;
  align-items: center;
  min-height: 42px;
  padding: 0.7rem 0.9rem;
  border-radius: 14px;
  text-decoration: none;
  color: var(--color-text-soft);
  transition:
    background-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard),
    transform var(--duration-fast) var(--ease-standard);
}

.nav-link:hover {
  background: rgba(15, 23, 42, 0.04);
  color: var(--color-text);
  transform: translateX(2px);
}

.nav-link.active {
  background: linear-gradient(135deg, rgba(0, 113, 227, 0.1), rgba(255, 255, 255, 0.8));
  color: var(--color-text);
  border: 1px solid rgba(0, 113, 227, 0.14);
}

@media (max-width: 1024px) {
  .sidebar {
    position: static;
    width: 100%;
    height: auto;
    margin: 0 0 1rem;
  }
}
</style>
